// extracted by mini-css-extract-plugin
export default {"onlineIndicator":"OnlineIndicator_onlineIndicator__eKHQE","online":"OnlineIndicator_online__S9lia","offline":"OnlineIndicator_offline__-lcQE"};